import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Sliders1_Hotels({ section }) {


  function updateClassBasedOnScreenSize() {
    const element = document.querySelector(".hotels-page-margin");

    if (!element) return;

    if (window.innerWidth >= 1024) {
      element.classList.add("mb-5");

    } else {
      element.classList.remove("mb-5");
    }




    const element_2 = document.querySelector(".index-slider");
    if (!element_2) return;
    if (element_2) {
      if (window.innerWidth >= 1024) {
        element_2.classList.add("exclusive-officer-sec");

      } else {
        element_2.classList.remove("exclusive-officer-sec");
      }
    }
  }

  // Run on page load and when resizing
  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);


  const [isScrolled, setIsScrolled] = useState(false);

  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024, // For screens smaller than 1024px
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768, // For screens smaller than 768px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 520, // For screens smaller than 520px
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsScrolled(scrollTop > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);






  const fallbackItems = [
    { title: 'Hyderabad', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/hyderabad.png', link_url: '/hotel-list' },
    { title: 'Mumbai', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/mumbai.png', link_url: '/hotel-list' },
    { title: 'Manali', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/manali.png', link_url: '/hotel-list' },
    { title: 'Ayodhya', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/ayodhya.png', link_url: '/hotel-list' },
    { title: 'Goa', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/goa.png', link_url: '/hotel-list' },
  ];
  const items = section?.Items?.length ? section.Items : fallbackItems;

  return (
    <div>
      <div className="container offers index-slider">
        <div class="popular-state pb-0 pt-0 hotels-page-margin">
          <div class="container">
            <div class="title">
              <h3 className="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Popular </span>}{section?.title || 'Destinations'}</h3>
            </div>
          </div>
        </div>

        <div className={`customer-logos slider slides-wrapper ${isScrolled ? "slider" : ""}`}>
          <Slider {...settings}>

            {items.map((item, index) => (
              <div className="card swiper-slide" key={`${item.title}-${index}`}>
                <div className="image-content">
                  <div className="card-image">
                    <a href={item.link_url || '/hotel-list'} target="_blank" rel="noreferrer">
                      <img src={item.image_url} alt={item.title || ''} className="card-img" />
                    </a>
                  </div>
                </div>
                <div className="card-content">
                  <a href={item.link_url || '/hotel-list'} target="_blank" rel="noreferrer">
                    <h2 className="properties-title"><span className="property-number">{item.subtitle?.split(' ')?.[0] || '1527'}</span> {item.subtitle?.replace(/^\S+\s*/, '') || 'Properties'} <i className="fa fa-arrow-right p-l-6"></i> </h2>
                  </a>
                </div>
              </div>
            ))}

          </Slider>
        </div>


      </div>
    </div>
  );
}

export default Sliders1_Hotels;
